"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnselectButtonsGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const actions_1 = require("src/actions");
const webexUI_1 = require("webexUI");
const FilterTypings_1 = require("./FilterTypings");
const UnselectButton_1 = require("./UnselectButton");
class UnselectButtonsGroup extends React.Component {
    static getDerivedStateFromProps(nextProps, state) {
        const unselectButtons = UnselectButtonsGroup.getUnselectButtons(nextProps);
        const areButtonsSame = UnselectButtonsGroup.areButtonsSame(unselectButtons, state.buttons);
        return areButtonsSame ? null : { buttons: unselectButtons };
    }
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.getInitState = () => ({
            buttons: [],
            hiddenButtonCount: 0,
        });
        this.renderButton = (button) => {
            return ((0, jsx_runtime_1.jsx)(UnselectButton_1.UnselectButton, { groupValue: button.groupValue, filterValue: button.filterValue, groupTitle: button.groupTitle, filterTitle: button.filterTitle, onFilterRemoved: button.onFilterRemoved, unselectable: button.unselectable, isHidden: button.isHidden }, button.key));
        };
        this.state = this.getInitState();
    }
    render() {
        const { buttons } = this.state;
        return ((0, jsx_runtime_1.jsx)("div", { className: "unselect-buttons-group hidden md:flex gap-4 flex-wrap", ref: this.buttonRef, children: buttons.length ? buttons.map(this.renderButton) : null }));
    }
}
exports.UnselectButtonsGroup = UnselectButtonsGroup;
UnselectButtonsGroup.getUnselectButtons = (props) => {
    const { filterGroupsOrder, filters, selectedFilters } = props;
    const buttons = [];
    filterGroupsOrder.forEach(groupValue => {
        if (selectedFilters[groupValue] && selectedFilters[groupValue].length > 0) {
            selectedFilters[groupValue].forEach(filterValue => {
                const filterIndex = (0, app_1.findIndex)(filters[groupValue].items, item => item.value === filterValue);
                const filterItem = (0, webexUI_1.safe)(filters[groupValue].items)[filterIndex] || {};
                const unselectable = filters[groupValue].guiType !== FilterTypings_1.FilterGroupGuiTypeEnum.Radio ||
                    (groupValue === FilterTypings_1.FilterGroupTypeAlias.Type && filters[groupValue].unselectable) ||
                    groupValue === FilterTypings_1.FilterGroupTypeAlias.Segment ||
                    groupValue === FilterTypings_1.FilterGroupTypeAlias.Archived;
                if (filterItem.documentsCount > 0) {
                    buttons.push({
                        filterTitle: filterItem.title,
                        filterValue,
                        groupTitle: filters[groupValue].title,
                        groupValue,
                        isHidden: false,
                        key: filterItem.value,
                        onFilterRemoved: unselectable
                            ? () => {
                                props.setIsContentLoading(true);
                                UnselectButtonsGroup.onFilterRemoved(groupValue, filterValue);
                            }
                            : null,
                        unselectable,
                    });
                }
            });
        }
    });
    return buttons;
};
UnselectButtonsGroup.onFilterRemoved = (groupValue, filterValue) => {
    actions_1.ActionsController.dispatch(actions_1.FilterableListActions.change(groupValue, filterValue, true));
};
UnselectButtonsGroup.areButtonsSame = (a, b, checkVisible = false) => {
    const arr1 = checkVisible ? a.filter(x => x.isHidden === false) : a;
    const arr2 = checkVisible ? b.filter(x => x.isHidden === false) : b;
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (const v of arr1) {
        const keyIsPresent = arr2.some(x => x.key === v.key);
        if (!keyIsPresent) {
            return false;
        }
    }
    return true;
};
